import * as React from 'react';

import Group from '@lightspeed/cirrus-group';
import Modal, { ModalBody, ModalFooter, ModalHeader } from '@lightspeed/cirrus-modal';
import { Button } from '@lightspeed/flame/Button';
import PropTypes from 'prop-types';

import LabelPrintErrors from '../LabelPrintErrors';
import LabelPrintModal from '../LabelPrintModal';

/**
 * Class Error displays the error message to the user if an issue happens
 */
class Error extends React.Component {
  /**
   * Construct the Error Modal
   * @param {Object} props - Component properties
   */
  constructor(props) {
    super(props);

    this.state = {
      error: LabelPrintErrors.errors[props.error],
    };

    this.trackMessage = 'generic';
    if (props.error === 'NO_PRINTER') {
      this.trackMessage = 'no printer connected';
    }

    this.handleCheckAgainOnClick = this.handleCheckAgainOnClick.bind(this);
  }

  handleCheckAgainOnClick() {
    this.props.setStep(LabelPrintModal.steps.PRINT);
  }

  /**
   * Render the Error modal
   * @returns {Object} DOM Element
   */
  render() {
    const isCheckAgainVisible = !~[
      'EMPTY_API_RESPONSE',
      'PAUSED',
      'OPENED',
      'OUT_OF_MEDIA',
    ].indexOf(this.props.error);

    return (
      <Modal
        className={`label-print-modal ${this.props.currentStep.toLowerCase()} cirrus responsive`}
        isOpen={this.props.show}
        onRequestClose={this.props.onHide}
      >
        <ModalHeader onCloseClicked={this.props.onHide}>{this.state.error.title}</ModalHeader>
        <ModalBody>
          <div className="cr-pt-4 cr-mb-4" data-test="zbp-label-print-modal">
            <div className="cr-flex cr-width-full cr-items-center cr-mb-4">
              <div className="cr-inline-flex cr-mr-4">
                <img
                  className="medal-printer-error"
                  src="https://d2o5po5b88zacb.cloudfront.net/dist/assets/lshash-118c0e2/images/label/medal-printer-error.svg"
                  alt="printer error"
                />
              </div>
              <div>
                <h4 className="cr-text cr-bold cr-mb-0">{this.state.error.body.title}</h4>
                <p className="cr-text-s">{this.state.error.body.description}</p>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="cr-flex cr-justify-between">
            <a href={LabelPrintModal.links.documentation} target="_blank" rel="noopener noreferrer">
              <Button variant="secondary">Help</Button>
            </a>
            {isCheckAgainVisible ? (
              <Group className="cr-justify-end">
                <Button onClick={this.props.onHide}>Cancel</Button>
                <Button variant="primary" onClick={this.handleCheckAgainOnClick}>
                  Check Again
                </Button>
              </Group>
            ) : (
              <Button onClick={this.props.onHide}>Close</Button>
            )}
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

Error.propTypes = {
  error: PropTypes.string.isRequired,
  setStep: PropTypes.func.isRequired,
  currentStep: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};

export default Error;
